<nav class="navbar navbar-expand-lg navbar-light bg-light" *ngIf="prequal.id">
  <span class=" mr-auto">
    <button mat-raised-button routerLink="../../" class="m-1 mr-2">
      <mat-icon>arrow_back</mat-icon> Back
    </button>

    <button mat-raised-button class="m-1 mr-2"
      routerLink="{{ prequal.id }}/edit" id="edit" *ngIf="app.account.isMasterAccount() && canEdit">
      <mat-icon>edit</mat-icon>
      Edit
    </button>

    <button mat-raised-button class="m-1 mr-2" color="warn" (click)="onDelete()" *ngIf="app.account.isMasterAccount() && canDelete">
      <mat-icon>delete</mat-icon>
      Delete
    </button>
  </span>

  <button mat-raised-button class="m-1 ml-auto" (click)="onDownloadPDF()" *ngIf="canView">
    <mat-icon>save_alt</mat-icon>
    Download as PDF
  </button>
</nav>

<div class="alert alert-warning m-2" *ngIf="noPrequalExists">
  <mat-icon class="align-middle mr-2">info</mat-icon>
  No pre-qualification exists for this contractor. You need create permission to add one.
</div>

<div class="alert alert-warning m-2" *ngIf="prequalExistsNoView">
  <mat-icon class="align-middle mr-2">info</mat-icon>
  A pre-qualification exists for this contractor. You need view permission to see it.
</div>

<div class="container-fluid p-0" *ngIf="!noPrequalExists && !prequalExistsNoView">

  <div class="card rounded-0">
    <div class="card-body">

      <div class="alert alert-info" role="alert" *ngIf="!app.account.isMasterAccount()">
          This Pre-Qualification is managed by "{{app.account.master_account.name}}". Please get in touch with them if you need to make any changes.
      </div>

      <div *ngIf="prequal.id">

        <ng-container *ngIf="canView">

        <h6>{{ utils.getLangTerm('contractors.singular', 'Contractor') }}</h6>
        <p>{{ prequal.contractor?.name }}</p>

        <ng-container *ngIf="prequal.description != ''">
          <h6>Pre-Qualification Description</h6>
          <p>{{ prequal.description }}</p>
        </ng-container>

        <h6>Health and Safety Score</h6>
        <p appPrequalScoreColor [scorePercentage]="prequal.score">
          {{ prequal.score }}%
        </p>

        <ng-container *ngIf="prequal.expires_at">
          <h6>Pre-Qualification Expiry Date</h6>
          <p [ngClass]="getExpiryClass(prequal.expires_at)">{{ (prequal.expires_at * 1000) | timezoneConvertShort }}</p>
        </ng-container>

        <p><sup>The {{ utils.getLangTerm('contractors.singular', 'Contractor') }} Pre-Qualification score is calculated based on the quantity of approved documents and their ratings.</sup></p>

        <app-contractors-items (change)="getPreQualification()" *ngIf="prequal.id"
          [prequalId]="prequal.id">
        </app-contractors-items>

        </ng-container>

      </div>

    </div>
  </div>

</div>
